import {App} from "@ova-studio/react-hyper-admin";
import MediaLibraryHelper from "./MediaLibraryHelper";
import MediaLibraryService from "./services/MediaLibraryService";

export default function initializer(app: App) {
    const service = new MediaLibraryService(app);
    app.services.register('media-library', service);
    app.helpers.register('initializer', MediaLibraryHelper, "auth");
}
